export default __webpack_public_path__ + "static/14-4418b23c8708d2d1536828d6259258e2.jpg";